import { render, staticRenderFns } from "./practice_test.vue?vue&type=template&id=8bd78d38&"
import script from "./practice_test.vue?vue&type=script&lang=js&"
export * from "./practice_test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports